/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { P as Popover, d as defineCustomElement$1 } from './popover.js';

const CalcitePopover = Popover;
const defineCustomElement = defineCustomElement$1;

export { CalcitePopover, defineCustomElement };

//# sourceMappingURL=calcite-popover.js.map